// <head> блога: title/description из полей статьи, canonical на себя,
// hreflang только на существующие переводы + x-default, JSON-LD Article и
// BreadcrumbList. Список: первая страница — hreflang на три списка; дальше —
// canonical на себя с ?page, без hreflang.
import blogCss from "./blog.css?url";
import { BLOG_COPY } from "./blog-copy";
import { SITE_CHROME_LINKS } from "@/components/site/site-chrome-head";
import { BLOG_PATH, articleJsonLd, blogBreadcrumbJsonLd, blogListHref, blogPostPath, postAlternates, type BlogLang, type BlogPost, type BlogTranslation } from "@/lib/blog";
import { OG_LOCALE, socialMeta } from "@/lib/page-meta";

const SITE = "https://yolutap.com";
const ld = (o: unknown) => ({ type: "application/ld+json", children: JSON.stringify(o).replace(/</g, "\\u003c") });

export function blogListHead(lang: BlogLang, page: number) {
  const c = BLOG_COPY[lang];
  const url = SITE + blogListHref(lang, page);
  const title = page > 1 ? `${c.meta.title} (${page})` : c.meta.title;
  return {
    meta: [...socialMeta({ title, description: c.meta.description }), { property: "og:type", content: "website" }, { property: "og:url", content: url }, { property: "og:locale", content: OG_LOCALE[lang] }],
    links: [
      { rel: "canonical", href: url },
      ...(page > 1
        ? []
        : [
            { rel: "alternate", hrefLang: "ru", href: SITE + BLOG_PATH.ru },
            { rel: "alternate", hrefLang: "az", href: SITE + BLOG_PATH.az },
            { rel: "alternate", hrefLang: "en", href: SITE + BLOG_PATH.en },
            { rel: "alternate", hrefLang: "x-default", href: SITE + BLOG_PATH.az },
          ]),
      ...SITE_CHROME_LINKS,
      { rel: "stylesheet", href: blogCss },
    ],
  };
}

/** title статьи: с « — Yolutap», если влезает в 60, иначе сам заголовок. */
export const postTitle = (title: string) => ([...`${title} — Yolutap`].length <= 60 ? `${title} — Yolutap` : title);

export function blogPostHead(post: BlogPost, translations: BlogTranslation[]) {
  const url = SITE + blogPostPath(post.lang, post.slug);
  return {
    meta: [
      ...socialMeta({ title: post.seo_title?.trim() || postTitle(post.title), description: post.description }),
      { property: "og:type", content: "article" },
      { property: "og:url", content: url },
      { property: "og:locale", content: OG_LOCALE[post.lang] },
      ...(post.cover_url ? [{ property: "og:image", content: post.cover_url }, { name: "twitter:card", content: "summary_large_image" }, { name: "twitter:image", content: post.cover_url }] : []),
    ],
    links: [
      { rel: "canonical", href: url },
      ...postAlternates({ lang: post.lang, slug: post.slug }, translations).map((a) => ({ rel: "alternate", hrefLang: a.hreflang, href: a.href })),
      ...SITE_CHROME_LINKS,
      { rel: "stylesheet", href: blogCss },
    ],
    scripts: [ld(articleJsonLd(post)), ld(blogBreadcrumbJsonLd(post))],
  };
}

/** Стили блога для чужих страниц (статьи коуча на /coaches). */
export const BLOG_CSS_LINK = { rel: "stylesheet", href: blogCss };
